
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fyrirtaeki/atomika",
      function () {
        return require("private-next-pages/fyrirtaeki/atomika.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fyrirtaeki/atomika"])
      });
    }
  